import {
  GET_PRODUCTS_LIST_FOR_DPP_REQUEST,
  GET_PRODUCTS_LIST_FOR_DPP_SUCCESS,
  GET_PRODUCTS_LIST_FOR_DPP_FAILURE,
  GET_ALL_DATA_FOR_DPP_REQUEST,
  GET_ALL_DATA_FOR_DPP_SUCCESS,
  GET_ALL_DATA_FOR_DPP_FAILURE,
  GET_TECHNICAL_DOCUMENTS_REQUEST,
  GET_TECHNICAL_DOCUMENTS_SUCCESS,
  GET_TECHNICAL_DOCUMENTS_FAILURE,
  GET_DURABILITY_REQUEST,
  GET_DURABILITY_SUCCESS,
  GET_DURABILITY_FAILURE,
  GET_COC_REQUEST,
  GET_COC_SUCCESS,
  GET_COC_FAILURE,
  GET_RAW_MATERIAL_REQUEST,
  GET_RAW_MATERIAL_SUCCESS,
  GET_RAW_MATERIAL_FAILURE,
  GET_PWM_REQUEST,
  GET_PWM_SUCCESS,
  GET_PWM_FAILURE,
  GET_EVT_REQUEST,
  GET_EVT_SUCCESS,
  GET_EVT_FAILURE,
  GET_REPAIR_MAINTAENANCE_REQUEST,
  GET_REPAIR_MAINTAENANCE_SUCCESS,
  GET_REPAIR_MAINTAENANCE_FAILURE,
  GET_MANUFACTURING_REQUEST,
  GET_MANUFACTURING_SUCCESS,
  GET_MANUFACTURING_FAILURE,
  GET_ITEMS_DETAILS_BY_DPP_ID_REQUEST,
  GET_ITEMS_DETAILS_BY_DPP_ID_SUCCESS,
  GET_ITEMS_DETAILS_BY_DPP_ID_FAILURE,
  GET_DPP_PARENT_REQUEST,
  GET_DPP_PARENT_SUCCESS,
  GET_DPP_PARENT_FAILURE,
  GET_CHILD_PARENT_REQUEST,
  GET_CHILD_PARENT_SUCCESS,
  GET_CHILD_PARENT_FAILURE,
   GET_TREE_MAP_REQUEST,
  GET_TREE_MAP_SUCCESS,
  GET_TREE_MAP_FAILURE,
} from "./dppTypes";

const initialState = {
  loading: false,
  productsListForDpp: [],
  error: "",
};

const getProductsListForDppReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_PRODUCTS_LIST_FOR_DPP_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_PRODUCTS_LIST_FOR_DPP_SUCCESS:
      return {
        loading: false,
        productsListForDpp: action.payload,
        error: "",
      };
    case GET_PRODUCTS_LIST_FOR_DPP_FAILURE:
      return {
        loading: false,
        productsListForDpp: [],
        error: action.payload,
      };
    default:
      return state;
  }
};
const initialStateS = {
  loading: false,
  dppCodes: [],
  error: "",
};

const getParentDppCodesReducer = (state = initialStateS, action) => {
  switch (action.type) {
    case GET_DPP_PARENT_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_DPP_PARENT_SUCCESS:
      return {
        loading: false,
        dppCodes: action.payload,
        error: "",
      };
    case GET_DPP_PARENT_FAILURE:
      return {
        loading: false,
        dppCodes: [],
        error: action.payload,
      };
    default:
      return state;
  }
};
const initialStatea = {
  loading: false,
  rawCodes: [],
  error: "",
};

const getParentRawCodesReducer = (state = initialStatea, action) => {
  switch (action.type) {
    case GET_CHILD_PARENT_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_CHILD_PARENT_SUCCESS:
      return {
        loading: false,
        rawCodes: action.payload,
        error: "",
      };
    case GET_CHILD_PARENT_FAILURE:
      return {
        loading: false,
        rawCodes: [],
        error: action.payload,
      };
    default:
      return state;
  }
};

const initialStateForMain = {
  loading: false,
  dpp: [],
  error: "",
};

const getAllDataForDppReducer = (state = initialStateForMain, action) => {
  switch (action.type) {
    case GET_ALL_DATA_FOR_DPP_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_ALL_DATA_FOR_DPP_SUCCESS:
      return {
        loading: false,
        dpp: action.payload,
        error: "",
      };
    case GET_ALL_DATA_FOR_DPP_FAILURE:
      return {
        loading: false,
        dpp: [],
        error: action.payload,
      };
    default:
      return state;
  }
};

const initialStateForTechnicalDocuments = {
  loading: false,
  technicalDocuments: [],
  error: "",
};

const getTechnicalDocumentsReducer = (
  state = initialStateForTechnicalDocuments,
  action
) => {
  switch (action.type) {
    case GET_TECHNICAL_DOCUMENTS_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_TECHNICAL_DOCUMENTS_SUCCESS:
      return {
        loading: false,
        technicalDocuments: action.payload,
        error: "",
      };
    case GET_TECHNICAL_DOCUMENTS_FAILURE:
      return {
        loading: false,
        technicalDocuments: [],
        error: action.payload,
      };
    default:
      return state;
  }
};

const initialStateForDurability = {
  loading: false,
  durability: [],
  error: "",
};

const getDurabilityReducer = (state = initialStateForDurability, action) => {
  switch (action.type) {
    case GET_DURABILITY_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_DURABILITY_SUCCESS:
      return {
        loading: false,
        durability: action.payload,
        error: "",
      };
    case GET_DURABILITY_FAILURE:
      return {
        loading: false,
        durability: [],
        error: action.payload,
      };
    default:
      return state;
  }
};

const initialStateForCoc = {
  loading: false,
  chainOfCustody: [],
  error: "",
};

const getChainOfCustodyReducer = (state = initialStateForCoc, action) => {
  switch (action.type) {
    case GET_COC_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_COC_SUCCESS:
      return {
        loading: false,
        chainOfCustody: action.payload,
        error: "",
      };
    case GET_COC_FAILURE:
      return {
        loading: false,
        chainOfCustody: [],
        error: action.payload,
      };
    default:
      return state;
  }
};

const initialStateForPackagingWasteManagement = {
  loading: false,
  packagingWasteManagement: [],
  error: "",
};

const getPackagingWasteManagementReducer = (
  state = initialStateForPackagingWasteManagement,
  action
) => {
  switch (action.type) {
    case GET_PWM_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_PWM_SUCCESS:
      return {
        loading: false,
        packagingWasteManagement: action.payload,
        error: "",
      };
    case GET_PWM_FAILURE:
      return {
        loading: false,
        packagingWasteManagement: [],
        error: action.payload,
      };
    default:
      return state;
  }
};

const initialStateForEnvironmental = {
  loading: false,
  environmental: [],
  error: "",
};

const getEnvironmentalReducer = (
  state = initialStateForEnvironmental,
  action
) => {
  switch (action.type) {
    case GET_EVT_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_EVT_SUCCESS:
      return {
        loading: false,
        environmental: action.payload,
        error: "",
      };
    case GET_EVT_FAILURE:
      return {
        loading: false,
        environmental: [],
        error: action.payload,
      };
    default:
      return state;
  }
};

const initialStateForRepairMaintenance = {
  loading: false,
  repairMaintenance: [],
  error: "",
};

const getRepairMaintenanceReducer = (
  state = initialStateForRepairMaintenance,
  action
) => {
  switch (action.type) {
    case GET_REPAIR_MAINTAENANCE_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_REPAIR_MAINTAENANCE_SUCCESS:
      return {
        loading: false,
        repairMaintenance: action.payload,
        error: "",
      };
    case GET_REPAIR_MAINTAENANCE_FAILURE:
      return {
        loading: false,
        repairMaintenance: [],
        error: action.payload,
      };
    default:
      return state;
  }
};

const initialStateForRawMaterial = {
  loading: false,
  rawMaterial: [],
  error: "",
};

const getRawMaterialReducer = (state = initialStateForRawMaterial, action) => {
  switch (action.type) {
    case GET_RAW_MATERIAL_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_RAW_MATERIAL_SUCCESS:
      return {
        loading: false,
        rawMaterial: action.payload,
        error: "",
      };
    case GET_RAW_MATERIAL_FAILURE:
      return {
        loading: false,
        rawMaterial: [],
        error: action.payload,
      };
    default:
      return state;
  }
};

const initialStateForManufacturing = {
  loading: false,
  manufacturing: [],
  error: "",
};

const getManufacturingReducer = (
  state = initialStateForManufacturing,
  action
) => {
  switch (action.type) {
    case GET_MANUFACTURING_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_MANUFACTURING_SUCCESS:
      return {
        loading: false,
        manufacturing: action.payload,
        error: "",
      };
    case GET_MANUFACTURING_FAILURE:
      return {
        loading: false,
        manufacturing: [],
        error: action.payload,
      };
    default:
      return state;
  }
};

const initialStateForItemsDetailsByDppId = {
  loading: false,
  itemsDetailsByDppId: [],
  error: "",
};

const getItemsDetailsByDppIdReducer = (
  state = initialStateForItemsDetailsByDppId,
  action
) => {
  switch (action.type) {
    case GET_ITEMS_DETAILS_BY_DPP_ID_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_ITEMS_DETAILS_BY_DPP_ID_SUCCESS:
      return {
        loading: false,
        itemsDetailsByDppId: action.payload,
        error: "",
      };
    case GET_ITEMS_DETAILS_BY_DPP_ID_FAILURE:
      return {
        loading: false,
        itemsDetailsByDppId: [],
        error: action.payload,
      };
    default:
      return state;
  }
};

const initialStateTreeMap = {
  loading: false,
  treeMapData: [],
  error: "",
};

const getTreeMapReducer = (state = initialStateTreeMap, action) => {
  switch (action.type) {
    case GET_TREE_MAP_REQUEST:
      return {
        ...state,
        loading: true,
        error: "",
      };
      
    case GET_TREE_MAP_SUCCESS:
      return {
        ...state,
        loading: false,
        treeMapData: action.payload,
        error: "",
      };
      
    case GET_TREE_MAP_FAILURE:
      return {
        ...state,
        loading: false,
        treeMapData: null,
        error: action.payload,
      };
      
    default:
      return state;
  }
};

export {
  getProductsListForDppReducer,
  getAllDataForDppReducer,
  getTechnicalDocumentsReducer,
  getDurabilityReducer,
  getChainOfCustodyReducer,
  getManufacturingReducer,
  getPackagingWasteManagementReducer,
  getEnvironmentalReducer,
  getRepairMaintenanceReducer,
  getRawMaterialReducer,
  getItemsDetailsByDppIdReducer,
  getParentRawCodesReducer,
  getParentDppCodesReducer,
  getTreeMapReducer,
};

